import ceb_PH from "./jsons/ceb_PH.json";
import en_MX from "./jsons/en_MX.json";
import en_PH from "./jsons/en_PH.json";
import en_US from "./jsons/en_US.json";
import en_ZA from "./jsons/en_ZA.json";
import es_CO from "./jsons/es_CO.json";
import es_EC from "./jsons/es_EC.json";
import es_MX from "./jsons/es_MX.json";
import es_PA from "./jsons/es_PA.json";
import es_PE from "./jsons/es_PE.json";
import id_ID from "./jsons/id_ID.json";
import pt_BR from "./jsons/pt_BR.json";
import tl_PH from "./jsons/tl_PH.json";

// Export admin-console specific translations
export default {
  ceb_PH,
  en_MX,
  en_PH,
  en_US,
  en_ZA,
  es_CO,
  es_EC,
  es_MX,
  es_PA,
  es_PE,
  id_ID,
  pt_BR,
  tl_PH,
};
